import { Injectable } from "@angular/core";
import { BehaviorSubject, filter, Subject } from "rxjs";
import { FilterFieldConfig } from "../filter.component";

@Injectable({ providedIn: 'root' })
export class FilterService {
  
  // #1 Streams for config, changes, scope
  private filterConfigSubject = new BehaviorSubject<FilterFieldConfig[]>([]);
  filterConfig$ = this.filterConfigSubject.asObservable();

  private filterChangesSubject = new Subject<any>();
  filterChanges$ = this.filterChangesSubject.asObservable();

  private filterScopeSubject = new BehaviorSubject<string>('default-scope');
  filterScope$ = this.filterScopeSubject.asObservable();

  private filterValuesMap: { [scope: string]: any } = {};

  setFilterConfig(config: FilterFieldConfig[]) {
    this.filterConfigSubject.next(config);
  }

  setFilterScope(filterScope: string): void {
    this.filterScopeSubject.next(filterScope);
  }

  applyFilters(filters: any) {
    this.filterChangesSubject.next(filters);
  }

  setFilters(scope: string, values: any) {
    this.filterValuesMap[scope] = values;
  }

  getFilters(scope: string): any {
    return this.filterValuesMap[scope] || {};
  }

  resetFilters(scope: string) {
    this.filterValuesMap[scope] = {};
  }

  setFiltersInScope(values: any) {
    const scope = this.filterScopeSubject.value; 
    this.setFilters(scope, values);
  }

  getFiltersInScope(): any {
    const scope = this.filterScopeSubject.value;
    return this.getFilters(scope);
  }

  restoreFiltersInScope(defaultValues: any) : any {
    const scope = this.filterScopeSubject.value;

    const savedValues = this.getFilters(scope); 
    
    if (!savedValues || Object.keys(savedValues).length === 0) {

      this.setFiltersInScope(defaultValues);
      this.applyFilters(defaultValues);
      
    } else {

      this.applyFilters(savedValues);
    }
  }
}